import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

import Vue from "vue";
import Vuetify from "vuetify/lib";

import { defaultConfigs } from "@/settings";
import { vuetifyI18n, locales } from "@/locale/index";
import themes from "./vuetifyThemes";

import fetixColors from "./fetixThemes";

Vue.use(Vuetify);

/**
 * Set basic config
 */
const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: fetixColors
    }
  },
  icons: {
    iconfont: "mdi"
  },
  lang: {
    locales,
    current: defaultConfigs.locale,
    t: (key, ...params) => vuetifyI18n.t(key, params)
  }
});

/**
 * Set theme with number for Vuetify class object
 *
 * @param {Number} index new value
 */
export async function setVuetifyTheme(index) {
  if (vuetify.framework.theme.themes !== themes[index]) {
    console.warn(`[Vuetify] Change theme to "${index}"`);
    vuetify.framework.theme.themes.light =
      themes[index].light || themes[0].light;
    vuetify.framework.theme.themes.dark = themes[index].dark || themes[0].dark;
  } else {
    console.warn(`[Vuetify] "${index}" is current theme `);
  }
}

/**
 * Set the mode to dark/light for the Vuetify class object.
 *
 * @param {Boolean} dark new value
 */
export async function setVuetifyThemeDark(dark) {
  console.warn(`[Vuetify] Change theme to "${dark ? "dark" : "light"}"`);
  vuetify.framework.theme.dark = dark;
}

export default vuetify;
